import { ROLES } from '@/constants/roles';
import { planNameByRole, planInstruction } from './functions';

export const uiEventPlan = {
  path: '/event-plan',
  name: 'event-plan',
  component: () => import('@/modules/EventsPlan/views/events-plan.vue'),
  meta: {
    layout: 'ui-design',
    buttonTitle: 'План',
    get title() {
      return planNameByRole();
    },
    new: true,
    uiDesign: true,
    wide: true,
    accessList: [ROLES.organization, ROLES.operator, ROLES.department],
    get instruction() {
      return planInstruction();
    },
  },
};
